import axios from 'axios';

import { CLIENT_URL } from '@/constants/index';

const Axios = axios.create({
  // admin panel integrated url:  http://digitalsales-01.azerconnect.az:8601
  // test url: http://134.122.125.111:8000
  baseURL: CLIENT_URL,
  // baseURL: 'http://134.122.125.111:8000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// FOR SERVER SIDE RENDERING BASE URL SHOULD BE http://digitalsales-01.azerconnect.az:8080/api
// FOR FRONTEND SIDE RENDERING BASE URL SHOULD BE https://new.bakcell.com/api/bkc-web/api
// FOR MEDIA https://new.bakcell.com/media/uploads/.....

export default Axios;
